import { Typography } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";

interface HobbiesProps {
  hobbies: string | null;
}

/**
 * This component displays the hobbies of an applicant.
 * @param hobbies The hobbies of an applicant
 * @returns The hobbies of an applicant.
 */
const Hobbies = ({ hobbies }: HobbiesProps) => {
  return (
    <ProfileDataCard title="Hobbies">
      <Typography>{hobbies}</Typography>
    </ProfileDataCard>
  );
};

export default Hobbies;
